module.exports = __webpack_public_path__ + "gold-laurus-f8d6685dfa878001ae4f938a82f40a67.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/image_generator/gold-laurus.png
// module id = 102
// module chunks = 0 1